import React, { Fragment, h } from "preact";
import './ExpandCard.scss'
import {useState} from "preact/hooks";

export default function ExpandCard({title, children, className, visibleDefault = false, iconVisible = '', iconHidden = '', expandable = true }){
    const [show, setShow] = useState(visibleDefault);
    const classShow = show ? 'show' : 'hide'

  function handleClick() {
    if (!expandable) return;
    setShow(!show);
  }

    return (
        <div className={`expandcard ${className}`}>
            <div className={`expandcard-header ${classShow} ${expandable ? '' : 'no-expand'}`} onClick={handleClick}>
              {title}

              {expandable && (
                show ? iconVisible : iconHidden
              )}
            </div>
            <div className={`expandcard-children ${classShow}`}>
                <div>
                  {show && (
                    <div>{children}</div>
                  )}
                </div>
            </div>
        </div>
    );
}
